<template>
  <VButton
    class="c-video-chapter"
    :class="{'c-video-chapter--active': isActive}"
    :aria-label="ariaLabelButton"
    @click.native="setCurrentTime()"
    :disabled="disabled"
  >
    <slot>{{ title }}</slot>
  </VButton>
</template>

<script>
import VButton from '@forlagshuset/v-button'

export default {
  name: 'video-chapter',

  components: {
    VButton
  },

  computed: {
    isActive() {
      if (!this.currentTime && !this.end) return false

      return this.currentTime >= this.start & this.currentTime <= this.end
    }
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    start: {
      type: Number,
      default: 0,
      required: true
    },
    end: {
      type: Number,
      default: 0
    },
    currentTime: {
      type: Number,
      default: 0
    },
    ariaLabelButton: {
      type: String,
      default: 'Go to video chapter'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    setCurrentTime() {
      this.$emit('video-chapter-click', this.start)
    }
  }
}
</script>

<style lang="scss">
.c-video-chapter {
  color: #29335c;
  background-color: #f7f6f5;
  border: 1px solid #f7f6f5;

  &:hover {
    background-color: #ebebeb;
  }

  &:disabled {
    background-color: rgba(#f7f6f5, 0.8);
  }

  &--active {
    background-color: #29335c;
    border: 1px solid #29335c;
    color: #fff;

    &:hover {
      background-color: #29335c;
    }

    &:disabled {
      background-color: rgba(#29335c, 0.8);
      border-color: rgba(#29335c, 0.8);
    }
  }
}
</style>
